import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const SITES_SITE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/sites',
        iconClass: 'fas fa-map',
        name: 'RegisterService::Menu:Sites',
        parentName: 'RegisterService::Menu:RegisterService',
        order: 27,
        layout: eLayoutType.application,
        requiredPolicy: 'RegisterService.Sites.Page',
      },
    ]);
  };
}
